import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workTypeGrid: [],
    workTypeAllCategory: [],
    workTypeGridAll: [],
    workTypeData: null,
    pageData: null,
  },
  mutations: {
    setWorkTypeGrid(state, payload) {
      state.workTypeGrid = payload
    },
    setWorkTypeGridAll(state, payload) {
      state.workTypeGridAll = payload
    },
    setWorkTypeAllCategory(state, payload) {
      state.workTypeAllCategory = payload
    },
    setWorkTypeData(state, payload) {
      state.workTypeData = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workTypeGrid: (state) => {
      return state.workTypeGrid
    },
    workTypeGridAll: (state) => {
      return state.workTypeGridAll
    },
    workTypeData: (state) => {
      return state.workTypeData
    },
    pageData: (state) => {
      return state.pageData
    },
    workTypeAllCategory: (state) => {
      return state.workTypeAllCategory
    },
  },
  actions: {
    onWorkTypeGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url = rootState.apiDomain + '/api/admin/work/type/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=id:desc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkTypeGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkTypeGridAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkTypeGridAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeAllCategory({ commit, rootState }, categoryId) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/type/grid?limit=0&filter[]=category_id:' +
            categoryId,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkTypeAllCategory', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeData({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkTypeData', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkTypeDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/type/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
